import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';

// Load fonts asynchronously without blocking app initialization
loadFonts().catch((error) => {
    console.warn('Font loading failed, continuing with default fonts:', error);
});

createApp(App).use(router).use(vuetify).mount('#app');
